// extracted by css-extract-rspack-plugin
export default {"container":"XvlRB8GDpikZexKK__container___","buyerName":"i8OWpvVZDYYoWsUN__buyerName___","profileLink":"EQKtHljeTF0zdFC0__profileLink___","logo":"TrdE3RkkIjIBpgOP__logo___"};